import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { BaseApiService } from '../base-api-service';

@Injectable({
  providedIn: 'root',
})
export class AdministratorsService extends BaseApiService {
  constructor() {
    super('administrators');
  }

  /**
   * Fonction de récupération des admins par application
   */
  byApplication(applicationId: string): Promise<any[]> {
    const params = new HttpParams().set('applicationId', applicationId);
    return this.get(this.apiUrl + 'application', params);
  }

  /**
   * Fonction de récupération des admins par utilisateurs
   */
  byUser(sapId: string): Promise<any[]> {
    const params = new HttpParams().set('sapId', sapId);
    return this.get(this.apiUrl + 'user', params);
  }

  /**
   * Fonction de création d'un admin
   */
  create(applicationId: string, sapId: string, firstName: string, lastName: string): Promise<any[]> {
    const params = new HttpParams()
      .set('ApplicationId', applicationId)
      .set('Vendor.SapId', sapId)
      .set('Vendor.FirstName', firstName)
      .set('Vendor.LastName', lastName);
    return this.post(this.apiUrl, {}, params);
  }

  /**
   * Fonction de modification d'un admin
   */
  update(applicationId: string, currentVendorSapId: string, sapId: string, firstName: string, lastName: string): Promise<any[]> {
    const params = new HttpParams()
      .set('ApplicationId', applicationId)
      .set('CurrentVendorSapId', currentVendorSapId)
      .set('Vendor.SapId', sapId)
      .set('Vendor.FirstName', firstName)
      .set('Vendor.LastName', lastName);
    return this.put(this.apiUrl, {}, params);
  }

  /**
   * Fonction de suppression d'un admin
   */
  delete(applicationId: string, vendorSapId: string): Promise<any[]> {
    const params = new HttpParams().set('ApplicationId', applicationId).set('VendorSapId', vendorSapId);
    return super.delete(this.apiUrl, undefined, params);
  }
}
